import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from '../components/api'

/*
import { useTabelaGestao } from '../context/GestaoPendenciasContext'
import moment from 'moment'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
*/

import Identificacao from './Energia_DadosProducao_Abas/Identificacao'
import Ambiente from './Energia_DadosProducao_Abas/Ambiente'
import EnergiaEletrica from './Energia_DadosProducao_Abas/EnergiaEletrica'
import Combustivel from './Energia_DadosProducao_Abas/Combustivel'
import Iluminacao from './Energia_DadosProducao_Abas/Iluminacao'
import HVAC from './Energia_DadosProducao_Abas/HVAC'
import Refrigeracao from './Energia_DadosProducao_Abas/Refrigeracao'
import Aquecimento from './Energia_DadosProducao_Abas/Aquecimento'

import GeradoresEstacionarios from './Energia_DadosProducao_Abas/GeradoresEstacionarios'
import SADT from './Energia_DadosProducao_Abas/SADT'


const DadosProducao = (props) => {

    //var { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()
    var energia_id = props.energia_id

    const [key, setKey] = useState('home')

    var atualizacaoGestao = ''

    

    var ano = props.ano
    //var [adesao_institucional_id, setAdesaoInstitucionalId] = useState(sessionStorage.getItem('adesao_institucional_id'))
    var adesao_institucional_id = props.adesao_institucional_id


    //console.log(adesao_institucional_id, '!!')

    


    useEffect(() => {

        window.$('[href="#tabEF0]').tab('show');



    }, [adesao_institucional_id, ano])





    return (

        <div>

            <div style={{ display: energia_id ? 'none' : 'block'}} >

                Por favor, preencha os Dados de consumo de energia e equipamentos primeiro!

            </div>



            <div style={{ display: energia_id ? 'block' : 'none'}} >

                <ul className="nav nav-tabs">
                        <li className="active"><a href="#tabEF0" data-toggle="tab">Identificação</a></li>
                        <li><a href="#tabEF1" data-toggle="tab">Ambientes</a></li>
                        <li><a href="#tabEF2" data-toggle="tab">Energia Elétrica</a></li>
                        <li><a href="#tabEF3" data-toggle="tab">Combustíveis</a></li>
                        <li><a href="#tabEF4" data-toggle="tab">Iluminação</a></li>
                        <li><a href="#tabEF5" data-toggle="tab">HVAC</a></li>
                        <li><a href="#tabEF6" data-toggle="tab">Refrigeração</a></li>
                        <li><a href="#tabEF7" data-toggle="tab">Aquecimento</a></li>
                        <li><a href="#tabEF8" data-toggle="tab">Geradores</a></li>
                        <li><a href="#tabEF9" data-toggle="tab">SADT</a></li>
                </ul>

                <div className="tab-content">

                <div className="tab-pane fade in active" id="tabEF0">
                        <div className="panel-body">

                        <Identificacao ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />


                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF1">
                        <div className="panel-body">

                        <Ambiente ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />


                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF2">
                        <div className="panel-body">

                        <EnergiaEletrica ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF3">
                        <div className="panel-body">

                        <Combustivel ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF4">
                        <div className="panel-body">

                        <Iluminacao ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF5">
                        <div className="panel-body">

                        <HVAC ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF6">
                        <div className="panel-body">

                        <Refrigeracao ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF7">
                        <div className="panel-body">

                        <Aquecimento ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>
                    <div className="tab-pane fade in" id="tabEF8">
                        <div className="panel-body">

                        <GeradoresEstacionarios ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tabEF9">
                        <div className="panel-body">

                        <SADT ano={ano} adesao_institucional_id={adesao_institucional_id} energia_id={energia_id} atualizacaoGestao={atualizacaoGestao} />

                        </div>

                    </div>

                </div>




            </div>

        </div>


    )


}

export default DadosProducao
